/** Sub-heading inside a record panel; shared by the Process and Deal snapshot panels. */
export const SUBHEAD = "text-[11px] font-semibold uppercase tracking-wider text-muted-foreground";
